<template>
  <div>
    <loadArea v-if="countries == null || branchs == null || load"></loadArea>
    <Form
      method="dialog"
      v-slot="{ errors }"
      v-if="countries != null && branchs != null && !load"
      class="floating-labels p-1rem row"
      ref="form"
    >
      <div class="col-lg-7">
        <div class="row">
          <div class="col-md-4">
            <formGroup
              :title="'Name'"
              v-model="model.Name"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'Title'"
              v-model="model.Title"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'BranchId'"
              :as="'select'"
              :disabled="countries.length == 0"
              :buttons="true"
              v-model="model.BranchId"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #input>
                <option :value="null"></option>
                <option
                  v-for="item in branchs"
                  :value="item.Id"
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
              <template #buttons>
                <button
                  type="button"
                  @click="addCountriesOpen = true"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </template>
            </formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'Person'"
              v-model="model.Person"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'Phone'"
              maska="0### ### ####"
              v-model="model.Phone"
              :errors="errors"
              :rules="{ min: 13 }"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'Email'"
              v-model="model.Email"
              :errors="errors"
              :rules="{ email: true }"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'TaxOffice'"
              v-model="model.TaxOffice"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'TaxNumber'"
              type="number"
              v-model.number="model.TaxNumber"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'CountryId'"
              :as="'select'"
              :disabled="countries.length == 0"
              :buttons="true"
              v-model="model.CountryId"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            >
              <template #input>
                <option
                  v-for="item in countries"
                  :value="item.Id"
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
              <template #buttons>
                <button
                  type="button"
                  @click="addCountriesOpen = true"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </template>
            </formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'DecDimension'"
              v-model.number="model.DecDimension"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'ProxyIP'"
              :buttons="true"
              v-model="model.ProxyIP"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #buttons>
                <Btn
                  type="button"
                  @click="getProxyIp"
                  :process="processProxyIp"
                  class="btn waves-effect waves-light btn-success"
                >
                  <i class="fas fa-question"></i>
                </Btn> </template
            ></formGroup>
          </div>
          <div class="col-md-4">
            <formGroup
              :title="'ProxyPort'"
              type="number"
              v-model.number="model.ProxyPort"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'Logo'"
              v-model="model.Logo"
              :errors="errors"
              @keydown.enter="save"
            >
            </formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'CustomApproveFormat'"
              :as="'select'"
              v-model="model.CustomApproveFormat"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #input>
                <option :value="false">Üstüne Yaz</option>
                <option :value="true">Yeni Sayfa Ekle</option>
              </template>
            </formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'WorkingModel'"
              :as="'select'"
              v-model="model.WorkingModel"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            >
              <template #input>
                <option value="yearly">Yearly</option>
                <option value="monthly">Monthly</option>
              </template>
            </formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'YearlyPrice'"
              type="number"
              v-model.number="model.YearlyPrice"
              :errors="errors"
              :rules="{ required: true }"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'City'"
              v-model="model.City"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-md-6">
            <formGroup
              :title="'Town'"
              v-model="model.Town"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-12">
            <formGroup
              :title="'Address'"
              :as="'textarea'"
              rows="5"
              v-model="model.Address"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
          </div>
          <div class="col-auto">
            <formGroup
              :title="'Notes To List'"
              :as="'checkbox'"
              v-model="model.NotesToList"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <div class="p-b-10"></div>
          </div>
          <div class="col-auto">
            <formGroup
              :title="'Active'"
              :as="'checkbox'"
              v-model="model.Active"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <div class="p-b-10"></div>
          </div>
          <div class="col-12">
            <div class="form-group focused">
              <input
                type="text"
                readonly=""
                class="focused form-control"
                name="ParasutId"
                :value="
                  (model.ParasutId == null ? '' : model.ParasutId) +
                    (parasutCustomer != null &&
                    parasutCustomer.filter((x) => {
                      return x.Id == model.ParasutId;
                    }).length > 0
                      ? ' - ' +
                        parasutCustomer.filter((x) => {
                          return x.Id == model.ParasutId;
                        })[0].ShortName
                      : '')
                "
                @dblclick="openParasut = true"
              />
              <label class="control-label">Parasut</label>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group focused">
              <input
                type="text"
                readonly=""
                class="focused form-control"
                name="Balance"
                :value="
                  parasutCustomer != null &&
                  parasutCustomer.filter((x) => {
                    return x.Id == model.ParasutId;
                  }).length > 0
                    ? $formatPrice(
                        parasutCustomer.filter((x) => {
                          return x.Id == model.ParasutId;
                        })[0].Balance
                      )
                    : ''
                "
                @dblclick="openParasut = true"
              />
              <label class="control-label">Balance</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 border-left">
        <div id="accordian-3">
          <div class="card m-b-0">
            <div class="card-header">
              <formGroup
                :title="'Kolayrez'"
                :as="'checkbox'"
                v-model="model.Kolayrez"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.Kolayrez">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'KolayrezStartDate'"
                      type="date"
                      v-model="model.KolayrezStartDate"
                      :rules="{ required: true }"
                      :max="model.KolayrezEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'KolayrezEndDate'"
                      type="date"
                      v-model="model.KolayrezEndDate"
                      :rules="{ required: true }"
                      :min="model.KolayrezStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'KolayrezAPI'"
                :as="'checkbox'"
                v-model="model.KolayrezAPI"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.KolayrezAPI">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'KolayrezAPIStartDate'"
                      type="date"
                      v-model="model.KolayrezAPIStartDate"
                      :rules="{ required: true }"
                      :max="model.KolayrezAPIEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'KolayrezAPIEndDate'"
                      type="date"
                      v-model="model.KolayrezAPIEndDate"
                      :rules="{ required: true }"
                      :min="model.KolayrezAPIStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'Tourscope'"
                :as="'checkbox'"
                v-model="model.Tourscope"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.Tourscope">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeStartDate'"
                      type="date"
                      v-model="model.TourscopeStartDate"
                      :rules="{ required: true }"
                      :max="model.TourscopeEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeEndDate'"
                      type="date"
                      v-model="model.TourscopeEndDate"
                      :rules="{ required: true }"
                      :min="model.TourscopeStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'TourscopeAPI'"
                :as="'checkbox'"
                v-model="model.TourscopeAPI"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.TourscopeAPI">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeAPIStartDate'"
                      type="date"
                      v-model="model.TourscopeAPIStartDate"
                      :rules="{ required: true }"
                      :max="model.TourscopeAPIEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeAPIEndDate'"
                      type="date"
                      v-model="model.TourscopeAPIEndDate"
                      :rules="{ required: true }"
                      :min="model.TourscopeAPIStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'TourscopeInKolayrez'"
                :as="'checkbox'"
                v-model="model.TourscopeInKolayrez"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.TourscopeInKolayrez">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeInKolayrezStartDate'"
                      type="date"
                      v-model="model.TourscopeInKolayrezStartDate"
                      :rules="{ required: true }"
                      :max="model.TourscopeInKolayrezEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'TourscopeInKolayrezEndDate'"
                      type="date"
                      v-model="model.TourscopeInKolayrezEndDate"
                      :rules="{ required: true }"
                      :min="model.TourscopeInKolayrezStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'FlightStats'"
                :as="'checkbox'"
                v-model="model.FlightStats"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.FlightStats">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'FlightStatsStartDate'"
                      type="date"
                      v-model="model.FlightStatsStartDate"
                      :rules="{ required: true }"
                      :max="model.FlightStatsEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'FlightStatsEndDate'"
                      type="date"
                      v-model="model.FlightStatsEndDate"
                      :rules="{ required: true }"
                      :min="model.FlightStatsStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'FlightControl'"
                :as="'checkbox'"
                v-model="model.FlightControl"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.FlightControl">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'FlightControlStartDate'"
                      type="date"
                      v-model="model.FlightControlStartDate"
                      :rules="{ required: true }"
                      :max="model.FlightControlEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'FlightControlEndDate'"
                      type="date"
                      v-model="model.FlightControlEndDate"
                      :rules="{ required: true }"
                      :min="model.FlightControlStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'ShortBazaar'"
                :as="'checkbox'"
                v-model="model.ShortBazaar"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.ShortBazaar">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'ShortBazaarStartDate'"
                      type="date"
                      v-model="model.ShortBazaarStartDate"
                      :rules="{ required: true }"
                      :max="model.ShortBazaarEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'ShortBazaarEndDate'"
                      type="date"
                      v-model="model.ShortBazaarEndDate"
                      :rules="{ required: true }"
                      :min="model.ShortBazaarStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'Chat'"
                :as="'checkbox'"
                v-model="model.Chat"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.Chat">
              <div class="card-header p-t-0">
                <div class="row">
                  <div class="col-6">
                    <formGroup
                      :title="'ChatStartDate'"
                      type="date"
                      v-model="model.ChatStartDate"
                      :rules="{ required: true }"
                      :max="model.ChatEndDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6">
                    <formGroup
                      :title="'ChatEndDate'"
                      type="date"
                      v-model="model.ChatEndDate"
                      :rules="{ required: true }"
                      :min="model.ChatStartDate"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header border-top">
              <formGroup
                :title="'Onay Bekleyen Bildirimleri'"
                :as="'checkbox'"
                v-model="model.ApprovalNotifyEnabled"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="collapse show" v-if="model.ApprovalNotifyEnabled">
              <div class="card-header p-t-0">
                <div class="row ">
                  <div class="col-6 p-2">
                    <formGroup
                      :title="'Bildirim Başlangıç Saati'"
                      type="time"
                      v-model="model.ApprovalNotifyStartTime"
                      :rules="{ required: true }"
                      :max="model.ApprovalNotifyEndTime"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6 p-2">
                    <formGroup
                      :title="'Bildirim Bitiş Saati'"
                      type="time"
                      v-model="model.ApprovalNotifyEndTime"
                      :rules="{ required: true }"
                      :min="model.ApprovalNotifyStartTime"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6 p-2">
                    <formGroup
                      :title="'Bildirim Sıklığı (Dakika)'"
                      type="number"
                      v-model.number="model.ApprovalNotifyFrequencyMinutes"
                      :rules="{ required: true, min_value: 15 }"
                      :errors="errors"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                  <div class="col-6 p-2 ">
                    <formGroup
                      :title="'Bildirim Kanalları'"
                      :as="'select'"
                      v-model.number="model.ApprovalNotifyChannels"
                      :rules="{ required: true }"
                      :errors="errors"
                      @keydown.enter="save"
                    >
                      <template #input>
                        <option :value="1">Push</option>
                        <option :value="2">Email</option>
                        <option :value="3">Push + Email</option>
                      </template>
                    </formGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <div class="modal-footer">
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="countries == null || branchs == null"
        :process="process"
        >{{ setModel != undefined ? "Update Customer" : "Add Customer" }}</Btn
      >
    </div>
  </div>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Id: $event.Id, Name: $event.Name })"
  ></addCountries>
  <parasut
    v-if="openParasut"
    :data="
      parasutCustomer.sort((x, y) => {
        return y.Balance - x.Balance;
      })
    "
    :selectId="model.ParasutId"
    @close="openParasut = false"
    @select="
      model.ParasutId = $event;
      openParasut = false;
    "
  ></parasut>
</template>

<script>
import addCountries from "@/views/countries/upsert";
import parasut from "./detail/parasut.vue";
export default {
  props: {
    setModel: Object,
  },
  components: { addCountries, parasut },
  data() {
    return {
      load: true,
      model: {
        Id: null,
        BranchId: null,
        Name: "",
        DecDimension: 2,
        ProxyIP: "",
        ProxyPort: "",
        CountryId: 228,
        WorkingModel: "yearly",
        WorkingPrice: null,
        City: "",
        Town: "",
        Title: "",
        TaxNumber: "",
        TaxOffice: "",
        Email: "",
        Person: "",
        Phone: "",
        Address: "",
        Kolayrez: true,
        KolayrezAPI: false,
        Tourscope: false,
        TourscopeAPI: false,
        TourscopeInKolayrez: false,
        FlightStats: false,
        FlightControl: false,
        ShortBazaar: false,
        Chat: false,
        Active: true,
        KolayrezStartDate: "",
        KolayrezEndDate: "",
        KolayrezAPIStartDate: null,
        KolayrezAPIEndDate: null,
        TourscopeStartDate: null,
        TourscopeEndDate: null,
        TourscopeAPIStartDate: null,
        TourscopeAPIEndDate: null,
        TourscopeInKolayrezStartDate: null,
        TourscopeInKolayrezEndDate: null,
        FlightStatsStartDate: null,
        FlightStatsEndDate: null,
        FlightControlStartDate: null,
        FlightControlEndDate: null,
        ShortBazaarStartDate: null,
        ShortBazaarEndDate: null,
        ChatStartDate: null,
        ChatEndDate: null,
        ParasutId: null,
        NotesToList: false,
        CustomApproveFormat: false,
        Logo: null,
        ApprovalNotifyEnabled: false,
        ApprovalNotifyStartTime: "09:00",
        ApprovalNotifyEndTime: "18:00",
        ApprovalNotifyFrequencyMinutes: 180,
        ApprovalNotifyChannels: 3,
      },
      process: false,
      countries: null,
      branchs: null,
      addCountriesOpen: false,
      parasutCustomer: null,
      openParasut: false,
      processProxyIp: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.$appAxiosAdmin
        .get(`Customers/` + this.setModel.Id)
        .then((response) => {
          this.model = response.data;
          if (this.model.KolayrezStartDate != null) {
            this.model.KolayrezStartDate = this.$moment(
              this.model.KolayrezStartDate
            ).format("YYYY-MM-DD");
            this.model.KolayrezEndDate = this.$moment(
              this.model.KolayrezEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.KolayrezAPIStartDate != null) {
            this.model.KolayrezAPIStartDate = this.$moment(
              this.model.KolayrezAPIStartDate
            ).format("YYYY-MM-DD");
            this.model.KolayrezAPIEndDate = this.$moment(
              this.model.KolayrezAPIEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.TourscopeStartDate != null) {
            this.model.TourscopeStartDate = this.$moment(
              this.model.TourscopeStartDate
            ).format("YYYY-MM-DD");
            this.model.TourscopeEndDate = this.$moment(
              this.model.TourscopeEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.TourscopeAPIStartDate != null) {
            this.model.TourscopeAPIStartDate = this.$moment(
              this.model.TourscopeAPIStartDate
            ).format("YYYY-MM-DD");
            this.model.TourscopeAPIEndDate = this.$moment(
              this.model.TourscopeAPIEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.TourscopeInKolayrezStartDate != null) {
            this.model.TourscopeInKolayrezStartDate = this.$moment(
              this.model.TourscopeInKolayrezStartDate
            ).format("YYYY-MM-DD");
            this.model.TourscopeInKolayrezEndDate = this.$moment(
              this.model.TourscopeInKolayrezEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.FlightStatsStartDate != null) {
            this.model.FlightStatsStartDate = this.$moment(
              this.model.FlightStatsStartDate
            ).format("YYYY-MM-DD");
            this.model.FlightStatsEndDate = this.$moment(
              this.model.FlightStatsEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.FlightControlStartDate != null) {
            this.model.FlightControlStartDate = this.$moment(
              this.model.FlightControlStartDate
            ).format("YYYY-MM-DD");
            this.model.FlightControlEndDate = this.$moment(
              this.model.FlightControlEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.ShortBazaarStartDate != null) {
            this.model.ShortBazaarStartDate = this.$moment(
              this.model.ShortBazaarStartDate
            ).format("YYYY-MM-DD");
            this.model.ShortBazaarEndDate = this.$moment(
              this.model.ShortBazaarEndDate
            ).format("YYYY-MM-DD");
          }
          if (this.model.ChatStartDate != null) {
            this.model.ChatStartDate = this.$moment(
              this.model.ChatStartDate
            ).format("YYYY-MM-DD");
            this.model.ChatEndDate = this.$moment(
              this.model.ChatEndDate
            ).format("YYYY-MM-DD");
          }
          this.model.ApprovalNotifyStartTime = this.model.ApprovalNotifyStartTime
            ? this.model.ApprovalNotifyStartTime.substring(0, 5)
            : "09:00";
          this.model.ApprovalNotifyEndTime = this.model.ApprovalNotifyEndTime
            ? this.model.ApprovalNotifyEndTime.substring(0, 5)
            : "18:00";
          if (!this.model.ApprovalNotifyFrequencyMinutes) {
            this.model.ApprovalNotifyFrequencyMinutes = 180;
          }
          if (!this.model.ApprovalNotifyChannels) {
            this.model.ApprovalNotifyChannels = 3;
          }
          this.load = false;
        });
    } else {
      this.load = false;
    }
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.$appAxiosAdmin.get(`Branchs`).then((response) => {
      this.branchs = response.data;
    });
    this.$appAxiosAdmin.get(`Parasut/Customers`).then((response) => {
      this.parasutCustomer = response.data;
    });
  },
  methods: {
    getProxyIp() {
      this.processProxyIp = true;
      this.$appAxiosAdmin
        .get("customers/" + this.setModel.Id + "/proxy")
        .then((response) => {
          this.$swal({
            icon: "info",
            title: "Info",
            text: response.data,
            confirmButtonText: "Okey",
          });
          this.processProxyIp = false;
        })
        .catch((err) => {
          this.$isError(err);
          this.processProxyIp = false;
        });
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          let model = { ...this.model };
          if (this.model.Phone != null) {
            model.Phone = this.model.Phone.toString()
              .replaceAll(" ", "")
              .slice(1, 13);
          }
          if (model.ProxyIP == "") {
            model.ProxyIP = null;
          }
          if (model.ProxyPort == "") {
            model.ProxyPort = null;
          }
          if (
            model.ApprovalNotifyStartTime != null &&
            model.ApprovalNotifyStartTime.length == 5
          ) {
            model.ApprovalNotifyStartTime += ":00";
          }
          if (
            model.ApprovalNotifyEndTime != null &&
            model.ApprovalNotifyEndTime.length == 5
          ) {
            model.ApprovalNotifyEndTime += ":00";
          }
          this.$appAxiosAdmin
            .put(`Customers`, model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The customer has been successfully updated."
                    : "The customer has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.collapse .card-header {
  background: none;
}
.collapse .card-header .row {
  margin: 0 -5px;
}
.collapse .card-header .row > div {
  padding: 0 5px;
}
/deep/.collapse .card-header .row > div .form-group {
  margin-bottom: 0;
}
</style>
